import { render, staticRenderFns } from "./AmountCard.vue?vue&type=template&id=e6f37c9c"
import script from "./AmountCard.vue?vue&type=script&lang=js"
export * from "./AmountCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports